import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';

import KDSSelect from '@decisiv/ui-components/lib/components/Select';

const Select = ({ name, defaultValue, options, ...props }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const handleChange = (id, onChange) => {
    const selectedOption = options.find((option) => option.id === id);

    onChange(selectedOption?.value ?? '');
  };

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => (
        <KDSSelect
          value={value}
          name={name}
          options={options}
          onChange={(id) => handleChange(id, onChange)}
          warningMessage={errors[name]?.message?.toString()}
          {...props}
        />
      )}
    />
  );
};

Select.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ).isRequired,
};

Select.defaultProps = {
  defaultValue: undefined,
};

export default Select;
